import Typography from '@material-ui/core/Typography';
import React from 'react';
import styled from 'styled-components';

import { PaperFavoriteType } from '../types/GraphQL';
import * as Util from '../util';

import { PaperCardContent } from './PaperCardContent';

const CreatedAt = styled(Typography)`
  margin-bottom: 0;
  text-align: right;
  font-size: 0.7rem;
`;

export const FavoritePaperCard: React.FC<{
  paperFavorite: PaperFavoriteType;
  truncatedLimit?: number;
}> = ({ paperFavorite, truncatedLimit = 300 }) => {
  const paper = paperFavorite.paperFull.paperSources?.[0];
  return paper ? (
    <div>
      <PaperCardContent
        paper={paper}
        tags={paperFavorite.paperFull.tags}
        truncatedLimit={truncatedLimit}
        footer={
          <CreatedAt color="textSecondary">
            Favorite at {Util.toLocaleString(paperFavorite.createdAt)}
          </CreatedAt>
        }
      />
    </div>
  ) : (
    <div> Paper not found</div>
  );
};
